import { Button } from '@uhg-abyss/web/ui/Button';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import find from 'lodash/find';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { adobeLinkTrackEvent } from '../../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { ConstantsLagoon } from '../../../../../common/ConstantsLagoon';
import { useLagoon } from '../../../../../hooks/useLagoon';

interface VirtualCareProviderModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedProviderName: string | null;
  virtualCareProviders: any;
}

export const VirtualCareProviderModal: React.FC<
  VirtualCareProviderModalProps
> = ({ isOpen, onClose, selectedProviderName, virtualCareProviders }) => {
  const { t } = useTranslation();
  const data = useLagoon('ui-messaging')();
  const modalContent = find(data, {
    key: ConstantsLagoon.VIRTUAL_CARE_PROVIDERS_BANNER
      .VIRTUAL_CARE_PROVIDER_MODAL_CONTENT,
  });
  return (
    <ModalDialog
      css={{
        'abyss-modal-base-content-container': {
          width: '572px',
        },
      }}
      data-testid="virtual-care-provider-modal"
      header={modalContent?.title}
      isOpen={isOpen}
      onClose={() => {
        adobeLinkTrackEvent({
          name: 'close',
          location: `modal:continue to site`,
          type: 'internal',
        });
        onClose();
      }}
    >
      <div data-testid="virtual-care-provider-modal-message">
        {modalContent?.message?.replace(
          '${selectedProviderName}',
          selectedProviderName ?? ''
        )}
      </div>
      <div>
        <Layout.Group alignLayout="right">
          <Button
            data-testid="cancel-button"
            onClick={() => {
              adobeLinkTrackEvent({
                name: 'cancel',
                location: `modal:continue to site`,
                type: 'internal',
              });
              onClose();
            }}
            variant="outline"
          >
            {t('THINGS_TO_CONSIDER_MODAL.CANCEL_BUTTON')}
          </Button>
          <Button
            data-testid="continue-button"
            onClick={() => {
              if (selectedProviderName) {
                const allProviders = Array.isArray(virtualCareProviders)
                  ? virtualCareProviders.every((group) => group.providers)
                    ? virtualCareProviders.flatMap(
                        (group) => group.providers || []
                      )
                    : virtualCareProviders
                  : virtualCareProviders?.providers || [];

                const provider = allProviders.find(
                  (p) => p.providerName === selectedProviderName
                );
                if (provider?.link) {
                  window.open(provider.link, '_blank');
                  adobeLinkTrackEvent({
                    name: 'continue',
                    location: `modal:continue to site`,
                    type: 'external',
                    destinationUrl: provider?.link,
                  });
                }
              }
              onClose();
            }}
          >
            {t('THINGS_TO_CONSIDER_MODAL.CONTINUE_BUTTON')}
          </Button>
        </Layout.Group>
      </div>
    </ModalDialog>
  );
};
